export class DriverImportResultModel {
  SuccessDriversCount: number;
  SuccessKeysCount: number;
  DriverNameDuplicates: string[] = [];
  DriverKeyUidDuplicates: string[] = [];


constructor(data?: any) {
    if (data) {
      this.init(data);
    }
  }

  init(data: any): void {
    console.log(data);
    this.SuccessDriversCount = data.successDriversCount || 0;
    this.SuccessKeysCount = data.successKeysCount || 0;
    this.DriverNameDuplicates = data.driverNameDuplicates || [];
    this.DriverKeyUidDuplicates = data.driverKeyUidDuplicates || [];
  }

  static fromJS(data: any): DriverImportResultModel {
    return new DriverImportResultModel(data);
  }
}
